import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { MapsService } from '@app/@services/maps.service';
import { NotificationModel } from '@shared/models/notifications.model';

@Component({
  selector: 'app-notifications-list',
  templateUrl: './notifications-list.component.html',
  styleUrls: ['./notifications-list.component.scss'],
  providers: [MapsService]
})
export class NotificationsListComponent implements OnInit {

  @Input() location: string;
  notificationsList: NotificationModel[] = [];

  constructor(private mapService: MapsService, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void { }

  updateNotifList(e: any): void {
    this.notificationsList = [];

    this.mapService.getNotificationsFromMessageCenter().subscribe((a: any) => {
      this.notificationsList = a;

    });

  }
}
